import { render, staticRenderFns } from "./CompanyRegistrationCertificateAddEditView.vue?vue&type=template&id=526a994c&scoped=true&"
import script from "./CompanyRegistrationCertificateAddEditView.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistrationCertificateAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegistrationCertificateAddEditView.vue?vue&type=style&index=0&id=526a994c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a994c",
  null
  
)

export default component.exports